import PropTypes from 'prop-types'
import React from 'react'
import styles from 'layouts/WideLayout/WideLayout.module.scss'
import { CloseButton } from 'layouts/WideLayout/subcomponents'
import Header from 'components/Header'
import { Grid } from 'gu-ui-kit'
import clsx from 'clsx'
import Footer from 'components/Footer'
import findMatchedRoutes, { getLastMatchedRoute } from 'utils/findMatchedRoutes'
import LayoutSuspense from 'layouts/LayoutSuspense'
import { WideLayoutProvider, useWideLayoutContext } from 'layouts/WideLayout/context'

const WideLayoutContent = ({
  children = null,
  className = '',
  hasToggler = true,
  hasCloseButton = true,
}) => {
  const { invokeClose } = useWideLayoutContext()
  const matchedRoutes = findMatchedRoutes()

  return (
    <Grid
      className={clsx(styles['layout'], className)}
      component={'section'}
      direction={'column'}
      wrap={false}
    >
      <Grid
        direction={'row'}
        fluid
        wrap={false}
        className={styles['layout__header-container']}
        gap={8}
      >
        <Grid className={styles['layout__header']}>
          <Header hasToggler={hasToggler} />
        </Grid>

        {hasCloseButton && <CloseButton onClose={invokeClose} />}
      </Grid>

      <Grid
        className={styles['layout__content']}
        wrap={false}
        direction={'column'}
      >
        <Grid
          className={clsx({
            'layout-tile': !getLastMatchedRoute(matchedRoutes)?.restyled,
          })}
          alignSelf={'start'}
          wrap={false}
          direction={'column'}
        >
          <LayoutSuspense>{children}</LayoutSuspense>
        </Grid>
      </Grid>
      <Footer wide />
    </Grid>
  )
}

WideLayoutContent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]),
  isExtra: PropTypes.bool,
}

const WideLayout = ({
  children = null,
  onClose,
  className = '',
  hasToggler = false,
  hasCloseButton = true,
}) => (
  <WideLayoutProvider defaultOnClose={onClose}>
    <WideLayoutContent
      className={className}
      hasToggler={hasToggler}
      hasCloseButton={hasCloseButton}
    >
      {children}
    </WideLayoutContent>
  </WideLayoutProvider>
)

WideLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
  onClose: PropTypes.func,
  contentClassName: PropTypes.string,
  className: PropTypes.string,
  hasToggler: PropTypes.bool,
  hasCloseButton: PropTypes.bool,
}

export default WideLayout
